import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TokenService } from './token.service';

export interface Machine {
  serial: string;
  name: string;
  swVersion: string;
  lastConnection: string;
  isConnected: boolean;
  isSetup: boolean;
}

@Injectable({ providedIn: 'root' })
export class MachineListService {
  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {}

  private getAuthHeaders() {
    const tokenTest = this.tokenService.getToken();
    console.log('Token exists? ', tokenTest ? 'yes' : 'no');
    const token = this.tokenService.getToken() || environment.jwtToken;
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    };
  }

  getMachines(page: number = 0, pageSize: number = 10, serial?: string): Observable<Machine[]> {
    const params = new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString()
    });
    if (serial && serial.trim()) {
      params.append('serial', serial.trim());
    }
    return this.http.get<Machine[]>(`https://${environment.backendUrl}/v1/machine-list?${params}`, { 
      headers: this.getAuthHeaders()
    });
  }

  setupMachine(id: string, isSetup: boolean): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(`https://${environment.backendUrl}/v1/setup-vpn-machine`, 
      { serialNumber: id, isNewSetup: !isSetup }, 
      { headers: this.getAuthHeaders() }
    );
  }

  deleteOpenVPNProfile(id: string): Observable<{ success: boolean }> {
    return this.http.delete<{ success: boolean }>(`https://${environment.backendUrl}/v1/delete-setup/${id}`,
        { headers: this.getAuthHeaders() }
    );
    return of({ success: true });
  }
}
